import type { UseCaseData } from "./types";
import { saasFoundersUseCase } from "./saas-founders";
import { collegeStudentsUseCase } from "./college-students";

const useCases: UseCaseData[] = [saasFoundersUseCase, collegeStudentsUseCase];

export function getUseCaseBySlug(slug: string): UseCaseData | undefined {
  return useCases.find((uc) => uc.slug === slug);
}

export function getAllUseCases(): UseCaseData[] {
  return useCases;
}

export type { UseCaseData };
export { saasFoundersUseCase, collegeStudentsUseCase };
